import { Component, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
  	selector: 'app-toolcards-evaluation-matrix',
  	templateUrl: './toolcards-evaluation-matrix.component.html',
  	styleUrls: ['./toolcards-evaluation-matrix.component.scss']
})
export class ToolcardsEvaluationMatrixComponent implements OnInit {
	public env;

  	constructor() { }

  	ngOnInit() {
  		this.env=environment;
  	}

}
